import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["currentSlide", "slideCount", "children"];
import { Icon } from '@livable/saas-react-components';
import { Button, Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Carousel from 'src/components/shared/Carousel';
import savings from 'src/img/savings.svg';
import { shuffleArray } from 'src/utils/shuffleArray';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
export const Saver = observer(_ref => {
  let tips = _ref.tips;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const shuffleList = Array.isArray(tips) ? shuffleArray(toJS(tips)).map(_ref2 => {
    let id = _ref2.id,
      tip = _ref2.tip;
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      key: id
    }, tip);
  }) : [];
  const CarouselArrowsFix = _ref3 => {
    let currentSlide = _ref3.currentSlide,
      slideCount = _ref3.slideCount,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded);
    return /*#__PURE__*/React.createElement("span", props, children);
  };
  const renderArrowPrev = clickHandler => {
    return /*#__PURE__*/React.createElement(CarouselArrowsFix, null, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      onClick: clickHandler,
      'custom-attribute': '535-dashboard-page'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-line-left"
    })));
  };
  const renderArrowNext = clickHandler => {
    return /*#__PURE__*/React.createElement(CarouselArrowsFix, null, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      onClick: clickHandler,
      'custom-attribute': '536-dashboard-page'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-line-right"
    })));
  };
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.saverContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.saveImgWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('dashboard_page.saver_title')), /*#__PURE__*/React.createElement("img", {
    src: savings,
    width: "160",
    height: "120",
    alt: "illustration savings",
    className: classes.saverImg
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.carouselWrapper
  }, /*#__PURE__*/React.createElement(Carousel, {
    list: shuffleList,
    prevArrowButton: renderArrowPrev(),
    nextArrowButton: renderArrowNext()
  }))));
});